import {Component, OnInit} from '@angular/core';
import {ClientService} from 'src/app/services/client.service';
import {CurrentUserService} from '../../../services/current-user.service';
import {Router} from '@angular/router';
import {ClientDTO} from '../../../model/clientDTO';
import {UserDTO} from '../../../model/userDTO';

@Component({
  styleUrls: ['./list-client.component.scss'],
  templateUrl: './list-client.component.html',
})
export class ListClientComponent implements OnInit {

  clients: Array<ClientDTO> = [];
  user: UserDTO;
  isLoading = false;

  constructor(private clientService: ClientService,
              private router: Router,
              private currentUserService: CurrentUserService) {
  }

  ngOnInit() {
    this.currentUserService.get().then(user => this.user = user);
    this.getAll();
  }

  getAll() {
    this.isLoading = true;
    this.clientService.getAll().subscribe(data => {
      this.clients = data;
      this.isLoading = false;
      if (data.length === 1) {
        this.openClient(data[0]);
      } else {
        this.clients = data;
        this.isLoading = false;
      }
    });
  }

  openClient(client) {
    this.router.navigate([`/bewind/${client.id}`]);
  }
}
